import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const listingsControlsSideBar = css`
  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      display: none;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      position: sticky;
      top: ${pxToRem(spacing.xl)};
      max-height: calc(100vh - ${spacing.xxxl}px);
      padding-bottom: ${spacing.xxxl}px;
      overflow-x: hidden;
      overflow-y: auto;
    `,
  )};
`;

export const totalProducts = css`
  margin-top: 0;
  ${responsiveText.BODY.SM};
  color: var(--brand-bluple-base);
`;
